import { useEffect, useState } from "react";
import { View } from "react-native";
import { useTranslations } from "@src/packages/i18n";
import {
  Dialog,
  DialogBodyText,
  DialogIcon,
  DialogTitleText,
  PrimaryButton,
  SecondaryButton,
} from "@louise/moon-ui";

const doorIcon =
  require("../../../../assets/images/you-icons/door-arch.png") as number;
type Props = {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

export default function LogoutModal({ visible, onClose, onConfirm }: Props) {
  const t = useTranslations();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => {
    if (!visible) setIsLoggingOut(false);
  }, [visible]);

  const handleConfirm = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    await onConfirm();
  };

  return (
    <Dialog visible={visible} onClose={onClose} layout="centered">
      <DialogIcon source={doorIcon} />
      <View accessibilityRole="header" style={{ marginTop: 16 }}>
        <DialogTitleText style={{ textAlign: "center" }}>
          {t("you.modals.logout.title")}
        </DialogTitleText>
      </View>
      <DialogBodyText style={{ textAlign: "center", marginBottom: 24 }}>
        {t("you.modals.logout.message")}
      </DialogBodyText>

      <View style={{ flexDirection: "row", gap: 12 }}>
        <SecondaryButton
          label={t("you.modals.logout.cancel")}
          onPress={onClose}
          flex={1}
        />
        <PrimaryButton
          label={t("you.modals.logout.confirm")}
          onPress={() => void handleConfirm()}
          loading={isLoggingOut}
          disabled={isLoggingOut}
          flex={1.5}
        />
      </View>
    </Dialog>
  );
}
